export const eventName = name => `kodix:smartContract:${name}`
